// extracted by mini-css-extract-plugin
export default {"card-stack-desc-wrapper":"card-stack-desc-wrapper_pglqp","button-group":"button-group_Pb5bY","timeline":"timeline_F63S1"};